import Icon from './components/Icon';
import Svg from './svg/session-student-absent.svg';
export default props => <Icon component={Svg} data-name="StudentAbsentIcon" {...props} />;